export const ADD_TIP_REQUEST = 'ADD_TIP_REQUEST'
export const ADD_TIP_SUCCESS = 'ADD_TIP_SUCCESS'
export const ADD_TIP_FALIURE = 'ADD_TIP_FALIURE'
